import styled from "styled-components";

import { theme } from "../../../themes/themes";
export const ContainCategoryCreate = styled.div`
  padding: 1rem;
  opacity: 1;
  h1 {
    grid-row: 1;
    text-align: left;
    color: ${({ theme }) => theme.primaryLight};
    margin: 0;
    font-size: 1.5em;
  }
  .header-wrapper {
    display: grid;
    grid-template-columns: 1fr;
    border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[600]};
  }
  .color-picker-input {
    visibility: hidden;
    height: 0;
    width: 0;
  }
`;

export const FormCard = styled.div`
  max-width: 445px;
  max-height: 380px;
  display: flex;
  flex-direction: column;
  width: 45vw;
  height: auto;
  font-size: 14px;
  border: 1px solid ${({ theme }) => theme.primaryLight};
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  background: ${({ theme }) => theme.neutral.white};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.primaryLight};

  @media only screen and (max-width: 480px) {
    width: 80vw;
  }

  svg {
    grid-row: 1;
    right: 15px;
    cursor: pointer;
    fill: red;
    transition: all ease 0.5s;
    align-self: center;
  }

  svg:hover {
    stroke: ${({ theme }) => theme.button.primary};
    stroke-width: 2px;
  }

  hr {
    width: 100%;
    grid-column: 1 / 01;
  }
`;

export const SectionWrapper = styled.div`
  padding: 1rem 1rem;
  display: flex;
  flex-direction: column;

  label {
    font-weight: bold;
    font-size: 14px;
  }

  textarea {
    resize: none;
  }

  input,
  textarea {
    padding: 0.5em;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    background-color: #f3f3f3;
    color: ${({ theme }) => theme.primaryIconColor};
  }

  input::placeholder {
    font-size: 12px;
  }
`;

export const ColorPicker = styled.div`
  background: ${({ theme }) => theme.neutral.white};
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  border-radius: 20px;
  height: 45px;
  display: grid;
  grid-template-columns: 86% 14%;
  align-items: center;
  svg {
    margin-left: 1.5rem;
    fill: ${({ theme }) => theme.neutral.black};
  }
  label {
    font-weight: 400;
  }
  label:hover {
    text-decoration: underline;
    cursor: pointer;
  }
  input {
    visibility: hidden;
    height: 0;
    width: 0;
  }
`;

export const ReqFieldMandatory = styled.div`
  color: red;
  font-size: 21px;
  font-weight: 400 !important;
  display: inline;
  margin-left: 5px;
`;

export const DefaultColors = styled.div`
  display: flex;
  margin: 10px 0;
  justify-content: space-around;
`;
export const ColorContainer = styled.div`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: ${({ bgcolor }) => bgcolor};
  &:hover {
    border: 1px solid;
  }
`;
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  .create-button {
    grid-row: 4;
    align-self: center;
    justify-self: right;
    margin-right: 0.4rem;
    width: auto;
    height: 2rem;
    outline: 0;
    padding: 6px 12px;
    color: ${({ theme }) => theme.neutral.white};
    border-radius: 5px;
    border: none;
    background: ${({ theme }) => theme.button.primary};
    transition: transform 0.1s ease;
  }

  .create-button:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
  .cancel-button {
    background-color: ${({ theme }) => theme.neutral.white};
    border: none;
    outline: none;
    text-decoration: underline;
    margin-right: 10px;
  }
`;
